import styled, { css } from 'styled-components';
import { basicColor, fontSnippets } from '@/styles/template';

 const Counter = styled.div<{ count: number }>`
	background: ${basicColor.red};
	color: ${basicColor.white};
	${fontSnippets.BS}; 
	font-size: 1.4rem;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	min-width: 3rem;
	height: 3rem; 
	border-radius: 50%;
  	vertical-align: middle;
  	padding-top: 1px;
	
	${({ count }) => (count > 99) && css`
		padding: 0 1rem;
		border-radius: 10px;
	`}
	
	white-space: nowrap; 
	line-height: 1;
	text-align: center;
`;

export default Counter;